import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'amber' | 'danger' | 'danger-ghost' | 'link';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: 'sm' | 'md' | 'big';
  block?: boolean;
  loading?: boolean;
  icon?: ReactNode;
}

/** Botão padrão (C-05 primário · C-06 fantasma · C-07 âmbar). */
export default function Button({ variant = 'primary', size = 'md', block, loading, icon, children, className = '', disabled, type = 'button', ...rest }: ButtonProps) {
  const cls = [
    'btn',
    variant === 'ghost' && 'ghost',
    variant === 'amber' && 'amber',
    variant === 'danger' && 'danger',
    variant === 'danger-ghost' && 'danger ghost',
    variant === 'link' && 'link',
    size === 'sm' && 'sm',
    size === 'big' && 'big',
    block && 'block',
    className,
  ].filter(Boolean).join(' ');
  return (
    <button type={type} className={cls} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {loading ? <span className="spinner" aria-hidden /> : icon}
      {children}
    </button>
  );
}
